// This plugin integrates the Localize service into the Nuxt application.
// Localize is a translation service that helps in translating the content of the application dynamically.
// The Localize script is included in the nuxt.config.ts file, which initializes the Localize service with the provided API key and configuration options.
// See: https://developers.localizejs.com/docs/library-api

import { defineNuxtPlugin } from '#app'

declare module '#app' {
  interface NuxtApp {
    $localize: Window['Localize']
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $localize: Window['Localize']
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('localize', window.Localize)
})
